// extracted by mini-css-extract-plugin
export default {"nav":"Burger_nav__SNtCq","burger":"Burger_burger__WR1qD","arrow":"Burger_arrow__bWboc","dropMenuWrapper":"Burger_dropMenuWrapper__1VQHZ","dropMenu":"Burger_dropMenu__LEk2D"};